/* eslint-disable camelcase */
import PagesEnum from "./enums/pages";
import ClicksEnum from "./enums/clicks";
import { trackClick, trackPage } from "@companion-core/shared/app/tracking/index";
import ClickTypes from "@companion-core/shared/app/tracking/enums/click-types";
import ChaptersEnum from "@companion-core/shared/app/tracking/enums/chapters";

export function trackPageRecommendedList(universeSlug: string) {
  return trackPage({
    page: PagesEnum.Recommendation,
    page_chapter1: ChaptersEnum.Onboarding,
    page_chapter2: universeSlug,
  });
}

export const trackSkipRecommendedListClick = (universeSlug: string) => {
  return trackClick({
    click_type: ClickTypes.Action,
    click: ClicksEnum.RecommendedListSkip,
    click_chapter1: ChaptersEnum.Onboarding,
    click_chapter2: universeSlug,
  });
};
